import React from "react";
import "./ScrollingText.css";

const ScrollingText = () => {
  return (
    <div className="scrolling-container">
      <div className="scrolling-text">
      Enjoy 10% off on your first purchase! Use code ‘WELCOME10’

      </div>
    </div>
  );
};

export default ScrollingText;
